import { useQuery } from '@tanstack/react-query';
import { getMaintenanceService } from '../../api/maintenance-service.ts';
import { normalizeNulls } from '../../utils/normalizeNulls.ts';

export default function useMaintenanceService(
  serviceId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['maintenanceServices', serviceId],
    queryFn: async () => {
      return await getMaintenanceService(serviceId);
    },
    select: normalizeNulls,
    enabled: !!serviceId && (options?.enabled ?? true),
  });
}
